import api from './api.js';

class TableConfigService {
    constructor(){
        this.base_url = 'TableConfig';
    }

    getConfig(tableType) {
        return api.get(`${this.base_url}/${tableType}`);
    }

    saveConfig(config) {
        return api.post(`${this.base_url}`, config);
    }
}

export default new TableConfigService;
